import { render, staticRenderFns } from "./myActivity.vue?vue&type=template&id=566a78de"
import script from "./myActivity.vue?vue&type=script&lang=js"
export * from "./myActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports